import React from "react";
// helmet
import { Helmet } from "react-helmet-async";
// react router dom
import { Link as RouterLink, useNavigate } from "react-router-dom";
// localization
import { useLocales } from "../../../locales";
// @mui
import { Alert, Box, Container, Grid, Typography } from "@mui/material";

import { useSettingsContext } from "../../../components/settings";
// components
import FormProvider, { RHFTextField } from "../../../components/hook-form";
// form
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  createParentForSchool,
  sendNotificationToParentsService,
} from "../../../redux/services/parents_service";
import { toast } from "react-toastify";

const txtFieldBorderStyle = {
  width: "100%",
  borderRadius: "4px",
  paddingBottom: "24px",

  "& .MuiFormLabel-root": {
    color: "#BCBCBC",
    fontSize: "16px",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    "& fieldset": {
      // borderColor: "rgba(255, 204, 99, 0.3)",
    },
    "&:hover fieldset": {
      border: "1px solid #ECECEC",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #ECECEC",
    },
  },
};

const labelSx = {
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "24px",
  color: "#535353",
};

const mainHolderSx = {
  p: { xs: "40px 25px", md: "40px", lg: "32px" },
  background: "#FFFFFF",
  boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "10px",
};

const boxTitleSx = {
  display: "flex",
  marginBottom: "29px",
  alignItems: "center",
};

const titleTypographySx = {
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "30px",
  paddingLeft: "13px",
  color: "#121212",
};

const loadingButtonStyle = {
  bgcolor: "#2E2857",
  height: "48px",
  color: (theme) =>
    theme.palette.mode === "light" ? "common.white" : "grey.800",
  "&:hover": {
    bgcolor: "text.primary",
    color: (theme) =>
      theme.palette.mode === "light" ? "common.white" : "grey.800",
  },
  fontSize: "16px",
  fontWeight: 600,
  paddingLeft: "103px",
  paddingRight: "103px",
};

const boxButtonSx = {
  marginTop: "66px",
  display: "flex",
  justifyContent: { lg: "flex-end", xs: "center" },
};

//____________________________________________________________________________
export default function SendNotificaationPage() {
  const { translate } = useLocales();

  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => state.parents);

  const navigate = useNavigate();

  const theme = useTheme();

  const { themeStretch } = useSettingsContext();

  const SendNotificaationPageScheema = Yup.object().shape({
    title: Yup.string().required(translate("title_is_required")),
    message: Yup.string().required(translate("message_is_required")),
  });

  const defaultValues = {
    title: "",
    message: "",
  };

  const methods = useForm({
    resolver: yupResolver(SendNotificaationPageScheema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data) => {
    try {
      // code
      dispatch(
        sendNotificationToParentsService({
         
          data: data,
        })
      ).then((response) => {
        console.log(response)
        if (
          response?.payload?.message === "Added Successfully" ||
          response?.payload?.message === "تمت الإضافة بنجاح"
        ) {
          toast(response.payload.message);
          navigate("/dashboard/families");
        }
      });
    } catch (error) {
      console.error(error);
     /* setError("afterSubmit", {
        ...error,
        message: error.message,
      });*/
    }
  };

  return (
    <>
      <Helmet>
        <title>{translate("send_notification")}</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <Box sx={boxTitleSx}>
          <img
            src="/assets/icons/dashboard/arrow.svg"
            alt=""
            style={{
              width: "7.1px",
              height: "15.84px",
              transform: theme.direction === "rtl" && "rotate(180deg)",
            }}
            onClick={() => navigate("/dashboard/families")}
          />
          <Typography sx={titleTypographySx}>
            {translate(`send_notification`)}
          </Typography>
        </Box>

        {/* ***************** Form **************** */}
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          {!!errors.afterSubmit && (
            <Alert severity="error">{errors.afterSubmit.message}</Alert>
          )}

          <Box sx={mainHolderSx}>
            <Grid container columnSpacing={{ xs: "40px", lg: "48px" }}>
              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>{translate("title")}</Typography>
                <RHFTextField
                  name="title"
                  type="text"
                  sx={txtFieldBorderStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography sx={labelSx}>{translate("msg")}</Typography>
                <RHFTextField
                  name="message"
                  type="text"
                  multiline
                  rows={3.5}
                  sx={txtFieldBorderStyle}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={boxButtonSx}>
            <LoadingButton
              onClick={handleSubmit(onSubmit)}
              color="inherit"
              size="large"
              type="submit"
              variant="Contained"
              sx={loadingButtonStyle}
              loading={isLoading}
            >
              {translate("send")}
            </LoadingButton>
          </Box>
        </FormProvider>
      </Container>
    </>
  );
}
